// Copyright 2025-2026 NXGN Management, LLC. All Rights Reserved.
import { useQuery } from 'react-query'

import { listObjectDefinitions } from '@/services/provisioning'

export const queryKey = (practiceId: string) =>
  ['objectDefinitions', practiceId] as const

export const useGetObjectDefinitions = (practiceId: string) => {
  return useQuery({
    queryKey: queryKey(practiceId),
    queryFn: () => listObjectDefinitions(practiceId),
  })
}
